import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ILargeShareholderListState } from '../states/large-shareholder-list.state';

export const selectLargeShareholderListState = createFeatureSelector<ILargeShareholderListState>('largeShareholderList');

export const selectLargeShareholderSearchFilter = createSelector(
  selectLargeShareholderListState,
  (state: ILargeShareholderListState) => state.searchFilter
);

export const selectLargeShareholderPagination = createSelector(
  selectLargeShareholderListState,
  (state: ILargeShareholderListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectLargeShareholderSort = createSelector(
  selectLargeShareholderListState,
  (state: ILargeShareholderListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectLargeShareholderListFullState = createSelector(
  selectLargeShareholderListState,
  (state: ILargeShareholderListState) => state
);
